var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"6694f8d27d003ff3816317854e1091269ede0c83"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'
import Analytics from './src/lib/analytics'

const sentryDsn = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN
const environment = process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.APP_ENV

const replay = new Sentry.Replay({
  blockAllMedia: true,
})

Sentry.init({
  dsn: sentryDsn,
  enabled: environment !== 'development',
  debug: false,
  environment: environment,
  release: process.env.npm_package_version,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1,
  tracesSampleRate: 1.0,
  beforeSend(event, hint) {
    const properties = {
      app: 'client',
      environment: event.environment,
      eventId: event.event_id,
      level: event.level,
      error: hint.originalException?.toString(),
      runtime: event.tags['runtime'],
      userEmail: event.user?.email,
      userId: event.user?.id,
      tags: event.tags,
    }

    Analytics.trackEvent('log.exception', {
      ...properties,
    })

    // TODO: We need to get the replayId from the event
    // this is broken right now, cause with this, replay will always exists
    const replayId = replay.getReplayId()
    if (replayId) {
      Analytics.trackEvent('log.replay', {
        sessionUrl: `https://curiotools.sentry.io/replays/${replayId}`,
        ...properties,
      })
    }
  },
  integrations: [replay],
})
